import { Field, useFormikContext } from 'formik';
import { t } from 'i18next';
import React from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';

const NextVisit = () => {
	const { values } = useFormikContext();
	const numberEntered = !!values?.nextVisit?.nextVisit;
	const dateEntered = !!values?.nextVisit?.nextVisitDate;

	return (
		<Row className='my-3'>
			<Card.Title>{t('VISIT.NEXT_VISIT')}</Card.Title>
			<Row>
				<Col md={3}>
					<Field
						name='nextVisit.nextVisit'
						type="number"
						as={Form.Control}
						placeholder={t('VISIT.ENTER_NUMBER')}
						disabled={!!dateEntered}
						value={values?.nextVisit?.nextVisit || ''}
					/>
				</Col>
				<Col md={3}>
					<Row>
						{['DAY', 'WEEK', 'MONTH'].map((period) => (
							<Col key={period} className='d-flex justify-content-center'>
								<Field name='nextVisit.period'>
									{({ field, form }) => (
										<Button
											className='w-100 mb-2'
											variant={field.value === period ? 'primary' : 'outline-primary'}
											onClick={() => form.setFieldValue('nextVisit.period', period)}
											disabled={!!dateEntered}
										>
											{t(`VISIT.${period}`)}
										</Button>
									)}
								</Field>
							</Col>
						))}
					</Row>
				</Col>
				<Col md={1} className='d-flex align-items-center justify-content-center'>
					<strong className='mb-0'>{t('GENERAL.OR')}</strong>
				</Col>
				<Col md={3}>
					<Field name='nextVisit.nextVisitDate'>
						{({ field }) => (
							<Form.Control
								type="date"
								{...field}
								value={field.value || ''}
								placeholder={t('VISIT.SELECT_DATE')}
								disabled={!!numberEntered}
							/>
						)}
					</Field>
				</Col>
			</Row>
		</Row>
	);
};

export default NextVisit;